import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { DialogFrame } from "component/shared/dialog-frame";
import { OutlinedButton } from "component/shared/outlined-button";
import { styles } from "./style";

interface OwnProps {
	open: boolean;
	id: string;
	title: string;
	confirmLabel: string;
	onConfirm: () => void;
	onCancel: () => void;
	children: React.ReactNode;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

/** Pause texting and Remove Business Tax ID. Closing it any way but the confirm button changes nothing. */
const Component: React.FC<Props> = ({ classes = {}, open, id, title, confirmLabel, onConfirm, onCancel, children }) => (
	<DialogFrame
		open={open}
		onClose={onCancel}
		title={title}
		titleId={`${id}-title`}
		aria-describedby={`${id}-body`}
		actions={
			<>
				<OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
				<Mui.Button variant="contained" color="primary" onClick={onConfirm}>
					{confirmLabel}
				</Mui.Button>
			</>
		}
	>
		<div id={`${id}-body`} className={classes.body}>
			{children}
		</div>
	</DialogFrame>
);

export const ConfirmDialog = withStyles(Component, styles);
